import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../../environments/environment';
import { firstValueFrom } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class CategoryService {

  categories: Array<{ id: string; name: string; }> = []

  endpoint = environment.endpoint;

  constructor(
    private http: HttpClient
  ) { }


  getAllCategory() {
    return firstValueFrom(this.http.get(`${this.endpoint}/product/category`));
  }

}
